import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ResolutionVoteStatistics } from 'src/lib/fliko/models/resolutions/resolution.data';
import { ResolutionVote } from 'src/lib/fliko/models/resolutions/resolution-enum';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-vote-progress',
  templateUrl: './vote-progress.component.html',
  styleUrls: ['./vote-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VoteProgressComponent implements OnInit {
  @Input() stats?: ResolutionVoteStatistics | null;
  @Input() detailed = false;

  public locale: string;

  constructor(public rwdService: RWDService, private ls: LocalizationService) {
    this.locale = this.ls.currentLocale;
  }

  ngOnInit(): void {}

  public getPercentage(vote: 'yes' | 'no' | 'hold' | 'sum'): number {
    return this.stats ? this.stats[vote].percentage : 0;
  }

  public forTransform(): { width: string; display: string } {
    // little trick here: "for" bar is at the background, so it should have length of both bars summed up
    const width = this.getPercentage(ResolutionVote.YES) + '%';
    return { width, display: 'inline-block' };
  }

  public againstTransform(): { width: string; display: string } {
    const width = this.getPercentage(ResolutionVote.YES) + this.getPercentage(ResolutionVote.NO) + '%';
    return { width, display: 'inline-block' };
  }

  public holdTransform(): { width: string; display: string } {
    const width = this.getPercentage('sum') + '%';
    return { width, display: 'inline-block' };
  }

  public getMissingVotes(): number {
    return 100 - this.getPercentage('sum');
  }
}
